<template>
  <div class="combin-detail">
    <el-dialog title="详情" :visible.sync="dialogVisible" width="1200px">
      <a-table :columns="detailColumns"></a-table>
    </el-dialog>
  </div>
</template>
<script>
import { Table } from "ant-design-vue";
import {detailColumns} from "../table"
export default {
  name: "combinDetail",
  components: {
    [Table.name]: Table,
  },
  data() {
    return {
      detailColumns,
      dialogVisible: false,
      num:''
    };
  },
};
</script>
<style lang="less" scoped></style>
